import React, { useEffect } from 'react';
import AkSpinner from '@atlaskit/spinner';
import { SpinnerContainer } from '../../styled/UserTrigger';
import { profileCardRendered } from '../../util/analytics';
var UserLoadingState = function UserLoadingState(_ref) {
  var fireAnalytics = _ref.fireAnalytics;
  useEffect(function () {
    fireAnalytics(profileCardRendered('user', 'spinner'));
  }, [fireAnalytics]);
  return /*#__PURE__*/React.createElement(SpinnerContainer, null, /*#__PURE__*/React.createElement(AkSpinner, null));
};
export default UserLoadingState;